















import Vue, { PropType } from 'vue';
import CoverLetterForm, {
  FormDataInterface,
} from '@/containers/cover-letters/form.vue';
import * as CoverLettersStore from '@/containers/cover-letters/store';
import { CoverLetter } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    CoverLetterForm,
  },
  props: {
    coverLetter: {
      type: Object as PropType<CoverLetter>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, content }: FormDataInterface) {
      const { id } = this.coverLetter;
      await this.$store.dispatch(
        CoverLettersStore.UpdateCoverLetter.namespaced({
          params: { id },
          body: { title, content },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cvs_path' });
    },
    async onDelete() {
      const { id } = this.coverLetter;
      await this.$store.dispatch(
        CoverLettersStore.DeleteCoverLetter.namespaced({ params: { id } })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      this.$router.push({ name: 'cvs_path' });
    },
  },
});
